import { render, staticRenderFns } from "./DiseaseTitle.vue?vue&type=template&id=071caa02&scoped=true"
import script from "./DiseaseTitle.vue?vue&type=script&lang=js"
export * from "./DiseaseTitle.vue?vue&type=script&lang=js"
import style0 from "./DiseaseTitle.vue?vue&type=style&index=0&id=071caa02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071caa02",
  null
  
)

export default component.exports